/* Cart instant open - PE (2026-10-10, Sasha: "add to cart takes 1-2 seconds of loading before the product is added").
 * Measured on LIVE (Oct 10, 4x CPU): tap -> drawer painted 1.13 s, of which Shopify's own /cart/add is 0.5-0.9 s of server
 * time (app cart functions; the same with or without section rendering) and the drawer HTML apply ~0.2 s.
 * The server wait cannot be shortened from the theme, so this script removes the *felt* wait: on the add-to-cart submit
 * it opens the cart drawer at once under the bridge's loading veil (assets/paex-cart-bridge.js setDrawerLoading: details
 * hidden + spinner + aria-busy + inert), and lifts the veil when the native product-form flow publishes cartUpdate
 * (sections already applied) or closes the drawer again on cartError so the form's inline error stays visible.
 * Native product-form.js is untouched: it still fetches, applies the sections and calls drawer.show() itself (a second
 * show() on an open drawer is a no-op apart from re-trapping focus). Scope: the PDP form and the sticky mini checkout
 * (both submit the product form). The quick-add modal keeps its own in-modal spinner (its CTA is inside a dialog above
 * the drawer). Opt-out: data-paex-cart-instant="off" on #Cart-Drawer.
 * Same evening (Sasha: "I do not see the instant open from the quick add on the PLP or from the ATC button on the
 * product tile"): window.PaexCartInstant = { arm(opener), lift(hide) } so the quick-add modal CTA
 * (assets/paex-quick-add.js) and the RCC tile circle (snippets/nimstrata.liquid) open the drawer under the veil the
 * same way; both lift through the same cartUpdate / cartError subscriptions. */
(function () {
  if (window.paexCartInstant) return;
  window.paexCartInstant = true;
  var armed = false;
  function drawer() { return document.getElementById('Cart-Drawer'); }
  function bridge() { return window.PaexCartBridge; }
  function lift(hideIt) {
    if (!armed) return;
    armed = false;
    var d = drawer(), b = bridge();
    if (b && typeof b.setDrawerLoading === 'function') b.setDrawerLoading(false);
    if (hideIt && d && typeof d.hide === 'function') { try { d.hide(); } catch (e) {} }
  }
  // Open the drawer NOW under the loading veil; returns true when it did (caller may then skip its own show()).
  function arm(opener) {
    var d = drawer(), b = bridge();
    if (!d || !b || typeof b.setDrawerLoading !== 'function' || typeof d.show !== 'function') return false;
    if (d.hasAttribute('data-status-silence') || d.getAttribute('data-paex-cart-instant') === 'off') return false;
    armed = true;
    b.setDrawerLoading(true);
    try { d.show(opener || null); } catch (e) { lift(false); return false; }
    // safety: never leave the veil on if neither event arrives (network black hole)
    setTimeout(function () { lift(false); }, 15000);
    return true;
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('product-form form, form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
    var host = form.closest('product-form');
    if (host && host.isloading) return;
    var btn = form.querySelector('[name="add"], .add-cart-button');
    if (btn && btn.hasAttribute('disabled')) return;
    arm(event.submitter || btn || null);
  }, true);
  window.PaexCartInstant = { arm: arm, lift: lift };
  function bind() {
    if (typeof webvista === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined' || typeof webvista.subscribe !== 'function') { setTimeout(bind, 100); return; }
    webvista.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { lift(false); });
    webvista.subscribe(PUB_SUB_EVENTS.cartError, function () { lift(true); });
  }
  bind();
})();
